import { Edit, RecordContextProvider, SortPayload, useGetList, useRecordContext } from "react-admin";
import { RteCommunicationV2ResourcesEnum } from "shared/enums/resourceMappings";
import { SitesBaseForm } from "../shared/components/SitesBaseForm";
import { GroupCertificationModalContextProvider } from "../hooks/useGroupCertifModal";
import CreateAssociatedGroupCertificationModal from "../create/CreateAssociatedGroupCertificationModal";

export const SiteEdit = () => {
  return (
    <GroupCertificationModalContextProvider>
      <Edit>
        <CustomEditContextProvider />
      </Edit>
      <CreateAssociatedGroupCertificationModal />
    </GroupCertificationModalContextProvider>
  );
};

const CustomEditContextProvider = () => {
  const rawRecord = useRecordContext();
  const { data } = useGetList(RteCommunicationV2ResourcesEnum.RteCommunicationConfig, {
    pagination: { page: 1, perPage: 100 },
    sort: { field: "id", order: "ASC" } as SortPayload,
    filter: {
      code_tm: rawRecord?.rte_code,
    },
  });

  const rteConfig = data && data.length > 0 ? data[0] : null;
  const record = {
    ...rawRecord,
    rte_code: rteConfig?.id,
  };

  return (
    <RecordContextProvider value={record}>
      <SitesBaseForm isCreateForm={false} />
    </RecordContextProvider>
  );
};
